const objectNames = {
  hu: {
    "Standard doboz - szoklival": "Standard doboz - szoklival",
    "Fiókos komód": "Fiókos komód",
    Munkalap: "Munkalap",
    "Standard ajtó": "Standard ajtó",
    "Fiókos szekrény": "Fiókos szekrény",
    "Sarok szekrény": "Sarok szekrény",
    "Mosogatós szekrény": "Mosogatós szekrény",
    "Válfa és Polcok és Fiókok - szekrény belső":
      "Válfa és Polcok és Fiókok - szekrény belső",
    "Páraelszívós szekrény": "Páraelszívós szekrény",
    "Standard ajtós szekrény": "Standard ajtós szekrény",
    "Sütő szekrény fiókkal": "Sütő szekrény fiókkal",
    "Ajtós szekrény felső nyitott résszel":
      "Ajtós szekrény felső nyitott résszel",
    "Nagy szekrény sütő és mikróval": "Nagy szekrény sütő és mikróval",
    "Ajtós szekrény 2": "Ajtós szekrény 2",
    "Fiókos szekrény 2": "Fiókos szekrény 2",
    Fiók: "Fiók",
    "Ajtós szekrény": "Ajtós szekrény",
    "Hátlemez - standard": "Hátlemez - standard",
    "Standard duplung": "Standard duplung",
    "Standard doboz": "Standard doboz",
    "Standard doboz - kötéssel": "Standard doboz - kötéssel",
    "Éjjeliszekrény - Ajtóval": "Éjjeliszekrény - Ajtóval",
    "Fiók - Ágynak": "Fiók - Ágynak",
    "Fiókok és Polcok - szekrény belső": "Fiókok és Polcok - szekrény belső",
    "Éjjeliszekrény - 2 fiókkal": "Éjjeliszekrény - 2 fiókkal",
    Ágy: "Ágy",
    "Éjjeliszekrény - 1 fiókkal": "Éjjeliszekrény - 1 fiókkal",
    "Éjjeliszekrény - 1 fiókkal és polccal":
      "Éjjeliszekrény - 1 fiókkal és polccal",
    "Polcok - szekrény belső": "Polcok - szekrény belső",
    "Tolóajtós szekrény": "Tolóajtós szekrény",
    "Válfák és polcok - szekrény belső": "Válfák és polcok - szekrény belső",
    "Ajtós szekrény alsó nyitott résszel":
      "Ajtós szekrény alsó nyitott résszel",
    "Hátlemez - darabolt": "Hátlemez - darabolt",
    Íróasztal: "Íróasztal",
    "Íróasztal 2": "Íróasztal 2",
    "Íróasztal 3": "Íróasztal 3",
    Adam: "Adam",
    "Adam (Másolat)": "Adam (Másolat)",
    "Íróasztal 4": "Íróasztal 4",
    "Íróasztal 5": "Íróasztal 5"
  },
  ro: {
    "Standard doboz - szoklival": "Cutie standard - cu soclu",
    "Fiókos komód": "Comodă cu sertare",
    Munkalap: "Blat de lucru",
    "Standard ajtó": "Ușă standard",
    "Fiókos szekrény": "Dulap cu sertare",
    "Sarok szekrény": "Dulap de colț",
    "Mosogatós szekrény": "Dulap chiuvetă",
    "Válfa és Polcok és Fiókok - szekrény belső":
      "Cuier și polițe și sertare - interior dulap",
    "Páraelszívós szekrény": "Dulap hotă",
    "Standard ajtós szekrény": "Dulap standard cu ușă",
    "Sütő szekrény fiókkal": "Dulap cuptor cu sertar",
    "Ajtós szekrény felső nyitott résszel":
      "Dulap cu ușă și parte superioară deschisă",
    "Nagy szekrény sütő és mikróval": "Dulap mare cuptor și microunde",
    "Ajtós szekrény 2": "Dulap cu ușă 2",
    "Fiókos szekrény 2": "Dulap cu sertare 2",
    Fiók: "Sertar",
    "Ajtós szekrény": "Dulap cu ușă",
    "Hátlemez - standard": "Spate - standard",
    "Standard duplung": "Dublură standard",
    "Standard doboz": "Cutie standard",
    "Standard doboz - kötéssel": "Cutie standard - cu legătură",
    "Éjjeliszekrény - Ajtóval": "Noptieră - cu ușă",
    "Fiók - Ágynak": "Sertar - pentru pat",
    "Fiókok és Polcok - szekrény belső": "Sertare și polițe - interior dulap",
    "Éjjeliszekrény - 2 fiókkal": "Noptieră - 2 sertare",
    Ágy: "Pat",
    "Éjjeliszekrény - 1 fiókkal": "Noptieră - 1 sertar",
    "Éjjeliszekrény - 1 fiókkal és polccal": "Noptieră - 1 sertar și poliță",
    "Polcok - szekrény belső": "Polițe - interior dulap",
    "Tolóajtós szekrény": "Dulap cu uși glisante",
    "Válfák és polcok - szekrény belső": "Cuiere și polițe - interior dulap",
    "Ajtós szekrény alsó nyitott résszel":
      "Dulap cu ușă și parte inferioară deschisă",
    "Hátlemez - darabolt": "Spate - segmentat",
    Íróasztal: "Birou",
    "Íróasztal 2": "Birou 2",
    "Íróasztal 3": "Birou 3",
    Adam: "Adam",
    "Adam (Másolat)": "Adam (Copie)",
    "Íróasztal 4": "Birou 4",
    "Íróasztal 5": "Birou 5"
  },
  en: {
    "Standard doboz - szoklival": "Standard box - with plinth",
    "Fiókos komód": "Drawer chest",
    Munkalap: "Worktop",
    "Standard ajtó": "Standard door",
    "Fiókos szekrény": "Drawer cabinet",
    "Sarok szekrény": "Corner cabinet",
    "Mosogatós szekrény": "Sink cabinet",
    "Válfa és Polcok és Fiókok - szekrény belső":
      "Wardrobe rail and shelves and drawers - cabinet interior",
    "Páraelszívós szekrény": "Hood cabinet",
    "Standard ajtós szekrény": "Standard door cabinet",
    "Sütő szekrény fiókkal": "Oven cabinet with drawer",
    "Ajtós szekrény felső nyitott résszel": "Door cabinet with open top",
    "Nagy szekrény sütő és mikróval": "Tall cabinet oven and microwave",
    "Ajtós szekrény 2": "Door cabinet 2",
    "Fiókos szekrény 2": "Drawer cabinet 2",
    Fiók: "Drawer",
    "Ajtós szekrény": "Door cabinet",
    "Hátlemez - standard": "Back panel - standard",
    "Standard duplung": "Standard double panel",
    "Standard doboz": "Standard box",
    "Standard doboz - kötéssel": "Standard box - with rail",
    "Éjjeliszekrény - Ajtóval": "Bedside table - with door",
    "Fiók - Ágynak": "Drawer - for bed",
    "Fiókok és Polcok - szekrény belső":
      "Drawers and shelves - cabinet interior",
    "Éjjeliszekrény - 2 fiókkal": "Bedside table - 2 drawers",
    Ágy: "Bed",
    "Éjjeliszekrény - 1 fiókkal": "Bedside table - 1 drawer",
    "Éjjeliszekrény - 1 fiókkal és polccal":
      "Bedside table - 1 drawer and shelf",
    "Polcok - szekrény belső": "Shelves - cabinet interior",
    "Tolóajtós szekrény": "Sliding door cabinet",
    "Válfák és polcok - szekrény belső":
      "Wardrobe rails and shelves - cabinet interior",
    "Ajtós szekrény alsó nyitott résszel": "Door cabinet with open bottom",
    "Hátlemez - darabolt": "Back panel - segmented",
    Íróasztal: "Desk",
    "Íróasztal 2": "Desk 2",
    "Íróasztal 3": "Desk 3",
    Adam: "Adam",
    "Adam (Másolat)": "Adam (Copy)",
    "Íróasztal 4": "Desk 4",
    "Íróasztal 5": "Desk 5"
  }
};

export default objectNames;
